import {createAction} from 'redux-act'

export const setTradeHistoryModalVisible = createAction('SET_TRADE_HISTORY_MODAL_VISIBLE')
export const setTradeHistoryForm = createAction('SET_TRADE_HISTORY_FORM')
export const closeTradeHistoryForm = createAction('CLOSE_TRADE_HISTORY_FORM')



